// TODO change locale default logic in V2
export const DISPLAY_LOCALE = "en-AU";

// Formats an amount in minor units (e.g. cents) using the currency's own number of decimal places
export function formatCurrencyAmount(amountMinor: number, currency: string): string {
  const formatter = new Intl.NumberFormat(DISPLAY_LOCALE, {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
  });
  const { maximumFractionDigits } = formatter.resolvedOptions();

  return formatter.format(amountMinor / 10 ** maximumFractionDigits);
}
